// extracted by mini-css-extract-plugin
export default {"cocreeSelect":"Cocree__cocreeSelect--FZMYn3_CWMjO0Hj9TAt4"};